export const environment = {
  production: true,
  apiUrl: 'https://api.pakmatti.com/api/',
  hostUrl: 'https://api.pakmatti.com/'
};
